import * as utility from '../misc/utility';

export interface IFileInfo {
    Id: string;
    IsFolder: boolean;
    Filename: string;
    ShowPolitiker: boolean;
    ShowPublik: boolean;
    FolderId?: string;
    CreatedTimestamp: string;
    UserModifiedTimestamp?: string|null;
    CreatedById: string;
}

export class FileInfo {
    Id: string;
    IsFolder: boolean;
    Filename: string;
    ShowPolitiker: boolean;
    ShowPublik: boolean;
    FolderId?: string;
    CreatedTimestamp: Date;
    UserModifiedTimestamp?: Date;
    CreatedById: string;

    constructor(src: IFileInfo) {
        this.Id = src.Id;
        this.IsFolder = src.IsFolder;
        this.Filename = src.Filename;
        this.ShowPolitiker = src.ShowPolitiker;
        this.ShowPublik = src.ShowPublik;
        this.FolderId = src.FolderId || undefined;
        this.CreatedTimestamp = utility.parseRequiredDate(src.CreatedTimestamp);
        this.UserModifiedTimestamp = utility.parseOptionalDate(src.UserModifiedTimestamp);
        this.CreatedById = src.CreatedById;
    }
}